import type { TenantContext } from "./tenant-context";

type TenantQueryKey = ["tenant", string | null, string | null];

let currentTenantQueryKey: TenantQueryKey = ["tenant", null, null];

export function setTenantQueryKey(context: TenantContext | null) {
  currentTenantQueryKey = ["tenant", context?.organizationId ?? null, context?.supportSessionId ?? null];
}

export function getTenantQueryKey(): TenantQueryKey {
  return currentTenantQueryKey;
}
